import { extend } from '@thd-nucleus/data-sources';

import { RatingsAndReviewsCondensed } from '@thd-olt-component-react/ratings-and-reviews';

export const QuickviewReviewsDrawerDataModel = extend(RatingsAndReviewsCondensed);
